var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDownloadingCheck = function SvgIconDownloadingCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M71.601 12.876c-1.19-1.168-3.14-1.168-4.329 0L31.261 48.059 12.715 29.811c-1.189-1.172-3.126-1.172-4.324 0l-6.499 6.346a2.955 2.955 0 0 0 0 4.231l27.187 26.743c1.19 1.159 3.126 1.159 4.329 0l44.687-43.674a2.947 2.947 0 0 0 0-4.25z"
  })));
};
export default SvgIconDownloadingCheck;